// assets/celebrity-grid-embed.js

class CelebrityGridEmbed {
  constructor(embedId) {
    this.embedId = embedId;
    this.section = document.getElementById(embedId);
    
    if (!this.section) return;
    
    this.root = this.section.querySelector('[data-celebrity-slider]');
    
    if (!this.root) return;
    
    this.init();
  }

  init() {
    if (this.root.splide) {
      this.enhanceSlider();
    } else if (window.Splide) {
      this.waitForSplide();
    }
  }

  enhanceSlider() {
    const splide = this.root.splide;
    if (!splide) return;

    const current = splide.options || {};
    const bp = current.breakpoints || {};

    // Mobile enhancement
    bp[767] = Object.assign({}, bp[767], {
      perPage: 1.2,
      gap: '12px'
    });

    splide.options({
      arrows: false,
      pagination: false,
      breakpoints: bp
    });

    if (typeof splide.refresh === 'function') {
      splide.refresh();
    }
  }

  waitForSplide() {
    let attempts = 0;
    const maxAttempts = 40;
    
    const timer = setInterval(() => {
      attempts++;
      
      if (this.root.splide) {
        clearInterval(timer);
        this.enhanceSlider();
      }
      
      if (attempts > maxAttempts) {
        clearInterval(timer);
        console.warn('Celebrity grid embed: Splide not initialized after waiting');
      }
    }, 50);
  }
}

// Initialize all celebrity grid embeds on the page
function initCelebrityGridEmbeds() {
  const sections = document.querySelectorAll('.celebrity-slider[id^="cg-article-"]');
  
  sections.forEach(section => {
    const embedId = section.getAttribute('id');
    new CelebrityGridEmbed(embedId);
  });
}

// Run on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCelebrityGridEmbeds);
} else {
  initCelebrityGridEmbeds();
}

// Export for potential external use
window.CelebrityGridEmbed = CelebrityGridEmbed;
window.initCelebrityGridEmbeds = initCelebrityGridEmbeds;